import React, {
	Component
} from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {Button,Icon, Tag, message, Checkbox } from 'antd';
/** PERSONAL */
import API from '@/API/api';
import TreeClassSelect from './treeClassSelect'


class KnowledgeBox extends Component {
	state = {
		historyTagsCheckedValues: [],
	}
	componentDidUpdate(prevProps, prevState) {
		if(
			(prevProps.data !== this.props.data || prevProps.historyData !== this.props.historyData) &&
			(this.props.data && this.props.data.selected && this.props.historyData)
		) {

			this.setState({
				historyTagsCheckedValues: []
			})
		}

	}

	historyClick = (checkedValues) => { //历史标签点击时 增加进选中标签中
		this.setState({
			historyTagsCheckedValues: [...checkedValues]
		})
		checkedValues.forEach((d) => {
			let has = this.props.data.selected.some((tag) => {
				return d === tag.id
			})
			if(!has) {
				let obj = this.props.historyData.find((tag) => {
					return d === tag.id
				})
				obj.well = '0'
				this.props.data.selected.push(obj)
			}
		})
		this.props.data.selected = [...this.props.data.selected]
		this.forceUpdate()

	}
	changeHideHistory = (val) => {
		let task_id = window.location.href.split('/').pop()
		let data = {
			task_id: task_id,
			hide_history: val
		}
		axios.post(API.CHANGE_HIDE_HISTORY, data).then((res) => {
			res = res.data
			if(res.code === 0) {
				this.props.changehideHistory(val)
				setTimeout(() => {
					this.forceUpdate()
				}, 0)
			} else {
				message.error(res.message);
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}
	render() {
		return(
			<div className="knowlist-container">
                <div className="knowlist-name" style={this.props.className ? {} : {fontSize:'18px',fontWeight:'600',marginTop:20}}>{this.props.data.title}</div>
                <div className="knowlist-box" style={{position: 'relative',border:'1px solid #00a2ae',borderRadius:'10px',padding:'10px 10px 35px'}}>
                    <div>
                        {
                            this.props.historyData&&this.props.historyData.length>0&&
                            <div style={{borderBottom:'1px solid #00a2ae',marginBottom:15,paddingBottom:10}}>
                                <div style={{fontSize:'15px',margin:'5px 0'}}>
                                    历史标签

                                    <Button style={{float:'right'}} onClick={()=>{this.changeHideHistory(~~(!(~~this.props.hideHistory)))}} type={this.props.hideHistory>0?'primary':''}>
                                        {this.props.hideHistory>0?'显示全部历史标签':'隐藏全部历史标签'}
                                    </Button>
                                </div>
                                <div>

                                    <Checkbox.Group onChange={this.historyClick} value={this.state.historyTagsCheckedValues} disabled={this.props.scene==='lookTask'}>
                                        {
                                            this.props.historyData.map((val,k)=>
                                            {
                                                if(
                                                        (!this.props.hideHistory)||
                                                        (this.props.hideHistory&&(k<10))
                                                    ){
                                                    return <Checkbox key={k} value={val.id}>{val.name}</Checkbox>
                                                }else{
                                                   return null
                                                }
                                            }
                                            )
                                        }
                                    </Checkbox.Group>
                                </div>
                            </div>
                        }

                    </div>
                    <div style={{overflowY:'auto',height:'80px'}} className={'knowledge_box_content'}>
                        {
                            this.props.data&&
                            this.props.data.selected&&
                            this.props.data.selected.map((val,k,arr)=>
                                <div key={k} style={{display:'inline-block',margin:'3px 0'}}>
                                    <div>
                                        <Tag color="#f50">{val.name}<Icon type="close" onClick={()=>{if(this.props.scene==='lookTask'){return};arr.splice(k,1);this.forceUpdate();this.props.okCallBackData&&this.props.okCallBackData.onOk()}}/></Tag>
                                    </div>
                                    <div style={{textAlign:'center',marginTop:3,cursor:'pointer'}}>
                                        {
                                            !this.props.hideWell&&
                                            <Tag color={parseInt(val.well)===1?"#87d068":''} onClick={()=>{if(this.props.scene==='lookTask'){return};parseInt(val.well)===1?(val.well='0'):(val.well='1');this.forceUpdate()}}>
                                                <Icon type="star" />主{this.props.data.title}
                                            </Tag>
                                        }

                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div style={{position:'absolute',bottom:10,right:10}}>
                        <Button onClick={()=>{this.setState({visible:true})}} disabled={this.props.scene==='lookTask'}>获取更多...</Button>
                        <TreeClassSelect visible={this.state.visible}
                                         onOk={()=>{this.setState({visible:false})}}
                                         onCancel={()=>{this.setState({visible:false})}}
                                        //  relate_id={this.props.select.find((d)=>{return d.type===this.props.data.pre_type})?this.props.select.find((d)=>{return d.type===this.props.data.pre_type}).selected:[{id:'0'}]}
                                         relate_id={this.props.select.find((d)=>{return d.type===this.props.data.pre_type})?this.props.select.find((d)=>{return d.type===this.props.data.pre_type}).selected:[{id:this.props.data.pre_type + ''}]}
                                         pre_type={this.props.data.pre_type}
                                         data={this.props.data}
                                         task_id={this.props.task_id}
                                         isTask={this.props.isTask}
                                         okCallBackData={this.props.okCallBackData}
                                         canSelectParentNode={this.props.canSelectParentNode}
                        />
                    </div>
                </div>
            </div>

		)
	}
}

const mapStateTopProps = state => {
	return {}
}
const mapDispatchToProps = dispatch => {
	return {

	}
};
export default connect(mapStateTopProps, mapDispatchToProps)(KnowledgeBox);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/question_tag_detail/knowledge_box/view.js